import style from './list-columns.scss';
import inView from 'in-view';
import timing from 'DesignSystem/motion/timing';

const script = () => {
  const cssClass: string = 'ListColumns';
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${cssClass}`] = true;

    // Activate in view on each item
    const items = elt.querySelectorAll(`.${cssClass}-item`);
    for (const item of items) {
      item.classList.add('isJsAnimated');
    }
    inView(`.${cssClass}-item`)
      .on('enter', (item:HTMLElement)=>{
        item.classList.add('isInViewport');
      });
  }
};

export {
  style,
  script,
};
